import { useState, useEffect } from 'react'

/**
 * Custom hook for managing localStorage.
 * @param {string} key - The key to use in localStorage.
 * @param {any} initialValue - The initial value to set if the key is not present in localStorage.
 * @returns {[any, function]} - Returns the current value and a function to update it.
 */
function useLocalStorage (key, initialValue) {
  // Initialize state with value from localStorage or with initialValue
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
    //   console.error(error)
      return initialValue
    }
  })

  // Update localStorage whenever the key or storedValue changes
  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue))
    } catch (error) {
    //   console.error(error)
    }
  }, [key, storedValue])

  // Function to update the stored value
  const setValue = (value) => {
    try {
      // Allow value to be a function to support functional updates
      const valueToStore = value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)
    } catch (error) {
    //   console.error(error)
    }
  }

  return [storedValue, setValue]
}

export default useLocalStorage
